import Headline from "../../../components/headline/headline";
import "./styles.scss";
import { HEADLINE_ORIENTATION } from "../../../constants/props";
import CaseCard from "../../../components/case-card/case-card";
import CustomDivider from "../../../shared/custom-divider/custom-divider";
import CustomRow from "../../../shared/costum-row/costum-row";
import { Col, Divider } from "antd";
import Testimonial from "../../../components/testimonial/testimonial";
import useBreakpoints from "../../../hooks/use-breakpoints";
import { BREAKPOINTS } from "../../../constants/styles";
import TestimonialCarousel from "../../../components/testimonals-carousel/testimonials-carousel";
import { CASES_CONTENT } from "../../../constants/content/pages/cases";

const Cases = () => {
  const currentBreakpoint = useBreakpoints();

  const isMobile =
    currentBreakpoint === BREAKPOINTS.TABLET.type ||
    currentBreakpoint === BREAKPOINTS.MOBILE.type;

  return (
    <div className="Cases-page">
      <Headline
        title={CASES_CONTENT.headline.title}
        subtitle={CASES_CONTENT.headline.subtitle}
        orientation={HEADLINE_ORIENTATION.BOTTOM}
      />
      {/* <CustomDivider /> */}
      <div className="Cases-container">
        {CASES_CONTENT.caseProjects.map((project) => (
          <CaseCard key={project.id} caseProject={project} />
        ))}
      </div>

      {/* <TestimonialCarousel /> */}
    </div>
  );
};

export default Cases;
